import storage from './storage.js';
// 用户-服务
export default {
  /**
   * 是否登录以及存入登录状态数据
   *
   * @param data 数据源字典
   */
  userLogin(data) {
    if (data == undefined) {
      if (this.userToken() == '') return false;
      return true;
    } else {
      this.userToken(data["token"]);
      return true;
    }
  },

  /**
   * 退出
   */
  userLogout() {
    storage.removeItem('userToken');
  },

  /**
   * 用户token
   */
  userToken(token = '') {
    if (token == '') return storage.getItem('userToken') || '';
      storage.setItem('userToken', token);
    return token;
  },
  userLang() {
    return storage.getItem('lang') || '';
  }

}



// WEBPACK FOOTER //
// ./src/assets/plugin/prototypes/modules/user.js